/**
 * Created by Jerker Nord on 2021-06-17.
 */

export interface SimpleReelModelSymbolData {
    name:string,
    positionable:Positionable,
    reelPosition:number
}

export interface Positionable {
    position:{
        x:number,
        y:number
    }
}

export interface SymbolPositionData {
    reelID:number;
    position:number
}


export interface SimpleReelModelDelegate {
    createSymbol(symbolName:string, state:SimpleReelModelState, position:SymbolPositionData):Positionable;

    removeSymbol(symbolData:SimpleReelModelSymbolData, state:SimpleReelModelState):void;
}

export enum SimpleReelModelState {
    IDLE = "IDLE",
    START = "START",
    SPIN = "SPIN",
    READY_TO_STOP = "READY_TO_STOP",
    STOPPING = "STOPPING",
    STOPPED = "STOPPED",
    BOUNCE = "BOUNCE"
}

export interface ISymbol {
    symbolName:string,
    reelPosition:number,
    reelTargetPosition:number,
    reelId:number
    position:PIXI.Point,
    isRemoved:boolean,
    splitLevel:number,
    stackedSymbolName:string,
    isStacked:boolean
}

export enum BenjiKIVSymbolStates {
    NORMAL,
    SPIN,
    WIN,
    NO_WIN,
    SPLIT,
    M_DEAD,
    M_DEAD_SPIN,
    WILD_2,
    WILD_2_SPIN,
    WILD_3,
    WILD_3_SPIN,
    WILD_DEAD,
    WILD_DEAD_SPIN
}

export enum BenjiKIVStackedSymbolPosition {
    TOP,
    MIDDLE,
    BOTTOM
}
